import type { ReactNode } from "react";

import { header } from "./SignUpHeader.styles";

interface Props {
  children: ReactNode;
  isStorefronts?: boolean;
}

const SignUpHeader = ({ children, isStorefronts = false }: Props) => {
  return <div css={header(isStorefronts)}>{children}</div>;
};

export { SignUpHeader };
